<div class="row">
  <div class="col-md-10 offset-md-2 text-left my-3 col-12">
    <h1 class="title">
      <span>IMPORT ABSTRACTS: <strong>{{activeProjectTitle}}</strong></span>
    </h1>
  </div>
</div>

<div class="row">
  <div class="card offset-md-2 col-md-6 col-12">
    <div class="card-body">
      <div class="row">
          <input type="file" id="upload" #upload
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                (change)="handleFileInput($event.target.files)">
          <button mat-raised-button class="mr-3 btn btn-primary" (click)="upload.click()">Select Abstracts Spreadsheet</button>
          <!--<button mat-raised-button (click)="downloadTemplate()">Download Template</button>-->
      </div>
      <div class="mt-3">
        <label class="font-weight-bold">File Name: </label>
        {{file?.name || 'n/a'}}
      </div>
      <div>
        <label class="font-weight-bold">File Size: </label>
        {{formatBytes(file?.size) || 'n/a'}}
      </div>
      <div class="mt-3">
        <button mat-raised-button 
                (click)="uploadFile()"
                [disabled]="isUploading"
                [ngClass]="file ? 'btn-success' : 'btn-danger'">Import Abstracts</button>
      </div>
    </div>
  </div>
</div>
